import produce from "immer";
import { LoadState } from "../../constants/enums";
import { IStoreState } from "../initialStoreState";
import { PartnersActions } from "./index";
import {
  CLEAR_BULK_ACTIVATION,
  CLEAR_BULK_ACTIVATION_STATE,
  CLEAR_PARTNER_MASTER,
  CLEAR_PARTNER_MASTER_STATE,
  CLEAR_PARTNER_MEMBERSHIP,
  CLEAR_PARTNER_MEMBERSHIP_STATE,
  CLEAR_PARTNER_PACKAGE_MASTER,
  CLEAR_PARTNER_PACKAGE_MASTER_STATE,
  CLEAR_COMPLAINT_LOG_STATE,
  FETCH_BULK_ACTIVATION_FAILED,
  FETCH_BULK_ACTIVATION_LIST_FAILED,
  FETCH_BULK_ACTIVATION_LIST_PROGRESS,
  FETCH_BULK_ACTIVATION_LIST_SUCCESS,
  FETCH_BULK_ACTIVATION_PROGRESS,
  FETCH_BULK_ACTIVATION_SUCCESS,
  FETCH_PARTNER_MASTER_FAILED,
  FETCH_PARTNER_MASTER_LIST_FAILED,
  FETCH_PARTNER_MASTER_LIST_PROGRESS,
  FETCH_PARTNER_MASTER_LIST_SUCCESS,
  FETCH_PARTNER_MASTER_PROGRESS,
  FETCH_PARTNER_MASTER_SUCCESS,
  FETCH_PARTNER_MEMBERSHIP_FAILED,
  FETCH_PARTNER_MEMBERSHIP_LIST_FAILED,
  FETCH_PARTNER_MEMBERSHIP_LIST_PROGRESS,
  FETCH_PARTNER_MEMBERSHIP_LIST_SUCCESS,
  FETCH_PARTNER_MEMBERSHIP_PROGRESS,
  FETCH_PARTNER_MEMBERSHIP_SUCCESS,
  FETCH_PARTNER_PACKAGE_MASTER_FAILED,
  FETCH_PARTNER_PACKAGE_MASTER_LIST_FAILED,
  FETCH_PARTNER_PACKAGE_MASTER_LIST_PROGRESS,
  FETCH_PARTNER_PACKAGE_MASTER_LIST_SUCCESS,
  FETCH_PARTNER_PACKAGE_MASTER_PROGRESS,
  FETCH_PARTNER_PACKAGE_MASTER_SUCCESS,
  FETCH_COMPLAINT_REPORT_LIST_PROGRESS,
  FETCH_COMPLAINT_REPORT_LIST_SUCCESS,
  FETCH_COMPLAINT_REPORT_LIST_FAILED,
  CLEAR_COMPLAINT_REPORT_DETAILS_LIST_STATE,
  FETCH_COMPLAINT_LOG_LIST_PROGRESS,
  FETCH_COMPLAINT_LOG_LIST_SUCCESS,
  FETCH_COMPLAINT_LOG_LIST_FAILED,
  FETCH_COMPLAINT_BY_MECHANIC_BY_CITY_LIST_PROGRESS,
  FETCH_COMPLAINT_BY_MECHANIC_BY_CITY_LIST_SUCCESS,
  FETCH_COMPLAINT_BY_MECHANIC_BY_CITY_LIST_FAILED,
  CLEAR_COMPLAINT_BY_MECHANIC_BY_CITY_STATE,
} from "./Partners.action";
import { initialPartnersState } from "./Partners.state";

export const partnersReducer = (
  state: IStoreState["partners"] = initialPartnersState,
  action: PartnersActions
) => {
  switch (action.type) {
    // ==================== PARTNER MASTER REDUCERS ====================
    case FETCH_PARTNER_MASTER_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.partnerMaster.list.loading = LoadState.InProgress;
        draftState.partnerMaster.list.list = [];
        draftState.partnerMaster.list.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_PARTNER_MASTER_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.partnerMaster.list.loading = LoadState.Loaded;
        draftState.partnerMaster.list.list = list;
        draftState.partnerMaster.list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_PARTNER_MASTER_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.partnerMaster.list.loading = LoadState.Failed;
        draftState.partnerMaster.list.list = [];
        draftState.partnerMaster.list.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_PARTNER_MASTER_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.partnerMaster.data.loading = LoadState.InProgress;
        draftState.partnerMaster.data.data = null;
      });
      return newState;
    }
    case FETCH_PARTNER_MASTER_SUCCESS: {
      const { partnerMaster } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.partnerMaster.data.loading = LoadState.Loaded;
        draftState.partnerMaster.data.data = partnerMaster;
      });
      return newState;
    }
    case FETCH_PARTNER_MASTER_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.partnerMaster.data.loading = LoadState.Failed;
        draftState.partnerMaster.data.error = errorMessage;
      });
      return newState;
    }
    case CLEAR_PARTNER_MASTER: {
      const newState = produce(state, (draftState) => {
        draftState.partnerMaster.data.loading = LoadState.NotLoaded;
        draftState.partnerMaster.data.data = null;
      });
      return newState;
    }
    case CLEAR_PARTNER_MASTER_STATE: {
      const newState = produce(state, (draftState) => {
        draftState.partnerMaster = initialPartnersState.partnerMaster;
      });
      return newState;
    }

    // ==================== PARTNER MEMBERSHIP REDUCERS ====================
    case FETCH_PARTNER_MEMBERSHIP_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.partnerMembership.list.loading = LoadState.InProgress;
        draftState.partnerMembership.list.list = [];
        draftState.partnerMembership.list.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_PARTNER_MEMBERSHIP_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.partnerMembership.list.loading = LoadState.Loaded;
        draftState.partnerMembership.list.list = list;
        draftState.partnerMembership.list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_PARTNER_MEMBERSHIP_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.partnerMembership.list.loading = LoadState.Failed;
        draftState.partnerMembership.list.list = [];
        draftState.partnerMembership.list.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_PARTNER_MEMBERSHIP_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.partnerMembership.data.loading = LoadState.InProgress;
        draftState.partnerMembership.data.data = null;
      });
      return newState;
    }
    case FETCH_PARTNER_MEMBERSHIP_SUCCESS: {
      const { partnerMembership } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.partnerMembership.data.loading = LoadState.Loaded;
        draftState.partnerMembership.data.data = partnerMembership;
      });
      return newState;
    }
    case FETCH_PARTNER_MEMBERSHIP_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.partnerMembership.data.loading = LoadState.Failed;
        draftState.partnerMembership.data.error = errorMessage;
      });
      return newState;
    }
    case CLEAR_PARTNER_MEMBERSHIP: {
      const newState = produce(state, (draftState) => {
        draftState.partnerMembership.data.loading = LoadState.NotLoaded;
        draftState.partnerMembership.data.data = null;
      });
      return newState;
    }
    case CLEAR_PARTNER_MEMBERSHIP_STATE: {
      const newState = produce(state, (draftState) => {
        draftState.partnerMembership = initialPartnersState.partnerMembership;
      });
      return newState;
    }

    // ==================== BULK ACTIVATION REDUCERS ====================
    case FETCH_BULK_ACTIVATION_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.bulkActivation.list.loading = LoadState.InProgress;
        draftState.bulkActivation.list.list = [];
        draftState.bulkActivation.list.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_BULK_ACTIVATION_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.bulkActivation.list.loading = LoadState.Loaded;
        draftState.bulkActivation.list.list = list;
        draftState.bulkActivation.list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_BULK_ACTIVATION_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.bulkActivation.list.loading = LoadState.Failed;
        draftState.bulkActivation.list.list = [];
        draftState.bulkActivation.list.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_BULK_ACTIVATION_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.bulkActivation.data.loading = LoadState.InProgress;
        draftState.bulkActivation.data.data = null;
      });
      return newState;
    }
    case FETCH_BULK_ACTIVATION_SUCCESS: {
      const { bulkActivation } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.bulkActivation.data.loading = LoadState.Loaded;
        draftState.bulkActivation.data.data = bulkActivation;
      });
      return newState;
    }
    case FETCH_BULK_ACTIVATION_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.bulkActivation.data.loading = LoadState.Failed;
        draftState.bulkActivation.data.error = errorMessage;
      });
      return newState;
    }
    case CLEAR_BULK_ACTIVATION: {
      const newState = produce(state, (draftState) => {
        draftState.bulkActivation.data.loading = LoadState.NotLoaded;
        draftState.bulkActivation.data.data = null;
      });
      return newState;
    }
    case CLEAR_BULK_ACTIVATION_STATE: {
      const newState = produce(state, (draftState) => {
        draftState.bulkActivation = initialPartnersState.bulkActivation;
      });
      return newState;
    }

    // ==================== PARTNER PACKAGE MASTER REDUCERS ====================
    case FETCH_PARTNER_PACKAGE_MASTER_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.partnerPackageMaster.list.loading = LoadState.InProgress;
        draftState.partnerPackageMaster.list.list = [];
        draftState.partnerPackageMaster.list.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_PARTNER_PACKAGE_MASTER_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.partnerPackageMaster.list.loading = LoadState.Loaded;
        draftState.partnerPackageMaster.list.list = list;
        draftState.partnerPackageMaster.list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_PARTNER_PACKAGE_MASTER_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.partnerPackageMaster.list.loading = LoadState.Failed;
        draftState.partnerPackageMaster.list.list = [];
        draftState.partnerPackageMaster.list.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_PARTNER_PACKAGE_MASTER_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.partnerPackageMaster.data.loading = LoadState.InProgress;
        draftState.partnerPackageMaster.data.data = null;
      });
      return newState;
    }
    case FETCH_PARTNER_PACKAGE_MASTER_SUCCESS: {
      const { partnerPackageMaster } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.partnerPackageMaster.data.loading = LoadState.Loaded;
        draftState.partnerPackageMaster.data.data = partnerPackageMaster;
      });
      return newState;
    }
    case FETCH_PARTNER_PACKAGE_MASTER_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.partnerPackageMaster.data.loading = LoadState.Failed;
        draftState.partnerPackageMaster.data.error = errorMessage;
      });
      return newState;
    }
    case CLEAR_PARTNER_PACKAGE_MASTER: {
      const newState = produce(state, (draftState) => {
        draftState.partnerPackageMaster.data.loading = LoadState.NotLoaded;
        draftState.partnerPackageMaster.data.data = null;
      });
      return newState;
    }
    case CLEAR_PARTNER_PACKAGE_MASTER_STATE: {
      const newState = produce(state, (draftState) => {
        draftState.partnerPackageMaster = initialPartnersState.partnerPackageMaster;
      });
      return newState;
    }

    // ==================== COMPLAINT LOG REDUCERS ====================
    case FETCH_COMPLAINT_LOG_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.complaintLog.list.loading = LoadState.InProgress;
        draftState.complaintLog.list.list = [];
        draftState.complaintLog.list.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_COMPLAINT_LOG_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.complaintLog.list.loading = LoadState.Loaded;
        draftState.complaintLog.list.list = list;
        draftState.complaintLog.list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_COMPLAINT_LOG_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.complaintLog.list.loading = LoadState.Failed;
        draftState.complaintLog.list.list = [];
        draftState.complaintLog.list.totalRecords = 0;
      });
      return newState;
    }
    case CLEAR_COMPLAINT_LOG_STATE: {
      const newState = produce(state, (draftState) => {
        draftState.complaintLog = initialPartnersState.complaintLog;
      });
      return newState;
    }


    // ==================== COMPLAINT BY MECHANIC BY CITY REDUCERS ====================
    case FETCH_COMPLAINT_BY_MECHANIC_BY_CITY_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.complaintByMechanicByCity.list.loading = LoadState.InProgress;
        draftState.complaintByMechanicByCity.list.list = [];
        draftState.complaintByMechanicByCity.list.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_COMPLAINT_BY_MECHANIC_BY_CITY_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.complaintByMechanicByCity.list.loading = LoadState.Loaded;
        draftState.complaintByMechanicByCity.list.list = list;
        draftState.complaintByMechanicByCity.list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_COMPLAINT_BY_MECHANIC_BY_CITY_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.complaintByMechanicByCity.list.loading = LoadState.Failed;
        draftState.complaintByMechanicByCity.list.list = [];
        draftState.complaintByMechanicByCity.list.totalRecords = 0;
      });
      return newState;
    }
    case CLEAR_COMPLAINT_BY_MECHANIC_BY_CITY_STATE: {
      const newState = produce(state, (draftState) => {
        draftState.complaintByMechanicByCity = initialPartnersState.complaintByMechanicByCity;
      });
      return newState;
    }

    // ==================== PARTNER COMPLAINT REPORT REDUCERS ====================
    case FETCH_COMPLAINT_REPORT_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.complaintReportDetails.list.loading = LoadState.InProgress;
        draftState.complaintReportDetails.list.list = [];
        draftState.complaintReportDetails.list.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_COMPLAINT_REPORT_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.complaintReportDetails.list.loading = LoadState.Loaded;
        draftState.complaintReportDetails.list.list = list;
        draftState.complaintReportDetails.list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_COMPLAINT_REPORT_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.complaintReportDetails.list.loading = LoadState.Failed;
        draftState.complaintReportDetails.list.list = [];
        draftState.complaintReportDetails.list.totalRecords = 0;
      });
      return newState;
    }
    case CLEAR_COMPLAINT_REPORT_DETAILS_LIST_STATE: {
      const newState = produce(state, (draftState) => {
        draftState.complaintReportDetails = initialPartnersState.complaintReportDetails;
      });
      return newState;
    }

    default:
      return state;
  }
};
